import React from 'react';

const AIWeeklyBrief = ({
  title,
  body,
  isRTL = false,
  periodLabel = '',
  cadenceLabel = '',
  refreshedLabel = '',
  onRequestRefresh,
  refreshLoading = false,
  refreshDisabled = false,
  refreshMessage = ''
}) => (
  <article className="executive-overview-panel executive-overview-brief">
    <div className="executive-overview-brief-head">
      <div>
        <div className="executive-overview-card-title">{title}</div>
        <div className="executive-overview-brief-meta">
          {[periodLabel, cadenceLabel, refreshedLabel].filter(Boolean).map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </div>
      {onRequestRefresh ? (
        <button
          type="button"
          className="executive-overview-brief-refresh"
          onClick={onRequestRefresh}
          disabled={refreshDisabled || refreshLoading}
        >
          <i className={`fa-solid ${refreshLoading ? 'fa-spinner fa-spin' : 'fa-rotate-right'}`} />
          <span>{refreshLoading ? (isRTL ? 'جارٍ التحديث' : 'Refreshing') : (isRTL ? 'طلب تحديث' : 'Request refresh')}</span>
        </button>
      ) : null}
    </div>
    <p className={`executive-overview-brief-copy${isRTL ? ' rtl' : ''}`}>
      {body || (isRTL ? 'لا يوجد ملخص مباشر متاح بعد.' : 'No live brief is available yet.')}
    </p>
    {refreshMessage ? <div className="executive-overview-brief-refresh-message">{refreshMessage}</div> : null}
  </article>
);

export default AIWeeklyBrief;
